import React from 'react'
import { FormattedMessage } from 'react-intl'
import { useLocation } from 'react-router-dom'
import Page from 'contexts/page'
import WhistleblowingCasesProvider from 'contexts/whistleblowing-cases'
import Statistics from './statistics'
import Caption from 'components/typography/caption'
import Filter from './filter'
import Cases from 'lists/whistleblowing/cases'
import { unresolvedStatusesFilter } from 'pages/whistleblowing/constants'

const UnresolvedCasesPane = () => {
    const namespace = 'whistleblowing.cases.unresolved'

    return (
        <>
            <Statistics namespace={namespace} />
            <Caption>
                <FormattedMessage
                    id="whistleblowing_unacknowledged_description"
                    defaultMessage="Acknowledge within 7 days" />
            </Caption>
            <Filter namespace={namespace} />
            <Cases />
        </>
    )
}

export default ({ title, upgradable, ...props }) => {
    const { state } = useLocation()

    return (
        <Page
            view="whistleblowing_unresolved"
            title={title}
            upgrade={{
                enabled: upgradable,
                tutorial: {
                    which: 'whistleblowing',
                    upgrade: { module: 'whistleblowing' }
                }
            }}>
            <WhistleblowingCasesProvider
                {...(!!state?.filter ? {
                    filter: state.filter,
                    filterOverride: true
                } : {
                    hiddenFilter: { statuses: unresolvedStatusesFilter }
                })}
                fetchStatisticsOnMount={true}>
                <UnresolvedCasesPane {...props} />
            </WhistleblowingCasesProvider>
        </Page>
    )
}